import axios from 'axios';
import Cookies from 'js-cookie';

const sendShareASalePixel = async () => {
    return false;
    //Gets cookies for original lead date and leadID
    let shareASaleHash = Cookies.get('shareASaleHash') ? Cookies.get('shareASaleHash') : false;
    let leadDate = Cookies.get('ShareASaleLeadDate') ? Cookies.get('ShareASaleLeadDate') : false;
    let SFLeadID = Cookies.get('SFLeadID') ? Cookies.get('SFLeadID') : false;
    if (shareASaleHash && leadDate && SFLeadID) {
        const createLead = await axios({
            method: 'POST',
            url: '/api/backend/webapi/v1/shareasale/lead',
            data: {
                shareASaleHash,
                leadDate,
                SFLeadID
            },
        });
        return createLead;
    }
};

export default sendShareASalePixel;
